import { z } from 'zod'

export const InfoDashboardSchema = z
  .object({
    start_date: z.date().nullable().optional(),
    end_date: z.date().nullable().optional(),
  })
  .refine(
    (data) => {
      if (data.start_date && data.end_date) {
        return data.end_date > data.start_date
      }
      return true
    },
    {
      message: 'End date must be greater than start date',
      path: ['end_date'],
    }
  )

export type InfoDashboardProps = z.infer<typeof InfoDashboardSchema>
